/* global $, prestashop */
/**
 * 2007-2023 A3WEB
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/OSL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    A3WEB
 * @copyright 2013-2023 A3WEB <https://www.a3web.fr>
 * @license   https://opensource.org/licenses/OSL-3.0 Open Software License (OSL 3.0)
 *
 */

$(document).ready(() => {
    var messageDiv = $('#error_message');
    messageDiv.show();
    setTimeout(function () {
        messageDiv.css("display", "none");
    }, 5000);

});